import { createStyles, makeStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      padding: "0px 20px",
    },
    tabPanelRoot: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-evenly",
    },
    photoRoot: {
      width: "min-content",
    },
    fieldItem: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: "16px",
      marginBottom: "36px",
      width: "500px",
      height: "36px",
    },
    fieldName: {
      marginRight: "12px",
      display: "flex",
      color: theme.palette.text.primary,
    },
    fieldContent: {
      width: "900px",
      display: "flex",
    },
    buttonBase: {
      margin: "24px 0px",
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
    },
    button: {
      marginLeft: "12px",
    },
    errorTypo: {
      color: "red",
    },
  });
export const useStyles = makeStyles(styles);

export const useDialogStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    display: "flex",
    flexDirection: 'column',
    alignItems: "center",
    padding: theme.spacing(2, 2)
  },
  text: {
    color: 'rgba(39, 58, 57, 0.8)',
    fontSize: '14px',
    lineHeight: '20px'
  },
  header: {
    color: '#273A39',
    fontSize: '22px',
    lineHeight: '30px',
    fontWeight: 'bold',
  }
}));
